export const DOCUMENT_RANGE_EXPORT_ID = 'document-range';

export const DOCUMENT_RANGE_TITLE = 'Rango de Documento';

export const LOCALIZED_PROPERTIES = {
  code: 'Código',
  emissionPoint: 'Punto de emisión',
  dateTimeStart: 'Fecha de Inicio',
  dateTimeEnd: 'Fecha de Fin',
  leftFormat: 'Formato izquierdo',
  rightFormat: 'Formato derecho',
  authorizationNumber: 'Número de autorización',
  documentType: 'Tipo de documento',
  documentClass: 'Clase de documento',
  lowerLimit: 'Límite inferior',
  upperLimit: 'Límite superior',
  initialValue: 'Valor inicial',
  currentValue: 'Valor actual',
  email: 'Correo electrónico',
  notifyAfter: 'Notificar después de',
  notifyWhenReachNumber: 'Notificar al llegar al número',
};
